<template>
  <div class="notification-main-container">
    <div
      class="notification-mobile-header d-flex align-items-center justify-content-between"
      id="hideinlaptop"
    >
      <div class="fw-600 font-primary fs-18 text-black">
        <img
          src="../assets/newimg/header/bckarw.svg"
          class="me-2"
          alt=""
          @click="$router.go(-1)"
        />
        Notifications
      </div>
      <div
        class="text-primary font-primary fw-700 fs-13 underline"
        v-if="notifications.length !== 0"
        @click="markAllRead"
      >
        Mark all as read
      </div>
    </div>
    <div class="notifications-dropdown">
      <!-- Header -->
      <div
        id="hideinmobile"
        class="dropdown-header d-flex justify-content-between align-items-center"
      >
        <strong class="fs-16 font-secondary charcoal-blue fw-600"
          >Notifications</strong
        >
        <div
          v-if="notifications.length !== 0"
          class="fs-12 font-primary fw-600 text-primary text-underline pointer"
          @click="markAllRead"
        >
          Mark all as read
        </div>
      </div>

      <!-- Notification List -->
      <section
        class="overflow-auto maxheight450px mobh100"
        ref="notiloop"
        @scroll="handleScroll"
      >
        <!-- Empty State -->
        <div
          class="mobmy0 d-flex flex-column align-items-center justify-content-center h-100"
          v-if="!isLoading && notifications.length === 0"
        >
          <img src="@/assets/newimg/header/emptynotification.svg" alt="" />
          <h6 class="dim-gray font-primary fw-600 fs-14 mt-2 mb-0">
            You don’t have any notifications
          </h6>
        </div>

        <!-- Loader Skeleton -->
        <div
          v-else-if="isLoading && notifications.length === 0"
          class="px-3 mt-2"
        >
          <b-skeleton
            v-for="i in 5"
            :key="i"
            height="60px"
            width="100%"
            class="mb-3"
          />
        </div>

        <!-- Notifications by Group -->
        <template v-else>
          <section
            v-for="(groupItems, groupName) in groupedNotifications"
            :key="groupName"
            class="w-100 px-3 my-2"
          >
            <!-- Group Title -->
            <h6 class="fw-600 fs-12 font-primary dim-gray">{{ groupName }}</h6>

            <div
              v-for="(item, index) in groupItems"
              :key="item.notificationID"
              class="w-100"
            >
              <div
                :class="{ unread: !item.read }"
                class="notiitems d-flex w-100 px-2 py-1 justify-content-between mt-1"
              >
                <!-- Message -->
                <div
                  v-html="item.message"
                  class="w-80 mob-fs-13 fs-14 fw-600 font-primary gunmetal-gray pointer"
                ></div>

                <!-- Right Side Options -->
                <div
                  class="fs-10 fw-600 dim-gray font-italic font-primary d-flex gap5px justify-content-end flex-column align-items-end"
                >
                  <div
                    class="d-flex align-items-center gap10px position-relative"
                    v-closeArray="{
                      index,
                      property: 'activeDropdownIndex',
                      array: groupItems,
                      handler: () => closenotiinsideDD(groupName, index),
                      exclude: ['notithreedots', 'excludeCard'],
                    }"
                    ref="excludeCard"
                  >
                    <img
                      src="@/assets/newimg/header/rightarrow.svg"
                      alt="Open"
                      class="pointer"
                      v-if="item.event && item.event.link"
                      @click.stop="openEvent(item.event, item.project)"
                    />
                    <img
                      src="@/assets/newimg/header/threedots.svg"
                      alt="Options"
                      class="pointer"
                      @click.stop="toggleDropdown(groupName, index)"
                      ref="notithreedots"
                    />
                    <div
                      v-if="item.activeDropdownIndex"
                      class="notification-markasread-dd pointer d-flex align-items-center ps-2"
                      @click="toggleReadStatus(item)"
                    >
                      <span
                        v-if="item.read"
                        class="fs-13 fw-600 gunmetal-gray font-primary font-normal"
                      >
                        Mark as unread
                      </span>
                      <span
                        v-else
                        class="fs-13 fw-600 gunmetal-gray font-primary font-normal"
                      >
                        Mark as read
                      </span>
                    </div>
                  </div>
                  <div>
                    {{ item.dateTimeText }}
                  </div>
                </div>
              </div>
              <hr
                v-if="index !== groupItems.length - 1"
                class="my-2 notification-hr"
              />
            </div>
          </section>
        </template>

        <!-- Loader Spinner for Infinite Scroll -->
        <div
          style="margin: auto"
          class="d-flex justify-content-center mb-3"
          v-if="showLoader"
        >
          <b-spinner label="Loading..."></b-spinner>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { getProcessedToken } from "@/utils/request";
import {
  getNotificationData,
  markasReadNotification,
  markasReadandUnreadNotification,
} from "@/utils/apiFunctions";
import errorToast from "@/components/mixin/toast";
import successToast from "@/components/mixin/toast";
import { appConfig } from "@/config/appConfig";
export default {
  name: "NotificationsDropdown",

  mixins: [errorToast, successToast],
  data() {
    return {
      notifications: [],
      page: 0,
      total: null,
      pageEnd: null,
      showLoader: false,
      isLoading: false,
      userID: null,
    };
  },
  computed: {
    unreadCount() {
      return this.notifications.totalUnreadCount;
    },
    groupedNotifications() {
      const grouped = {};
      this.notifications.forEach((item) => {
        const group = item.daysText || "Others";
        if (!grouped[group]) grouped[group] = [];
        grouped[group].push(item);
      });
      return grouped;
    },
  },
  created() {
    this.userID = getProcessedToken();
  },
  mounted() {
    this.fetchNotifications();
  },
  //   watch: {
  //     notifications: {
  //       handler(newVal) {
  //         this.$emit("update-unread-count", newVal.filter((n) => !n.read).length);
  //       },
  //       deep: true,
  //     },
  //   },
  methods: {
    async fetchNotifications() {
      try {
        this.isLoading = true;
        const payload = {
          userID: this.userID,
          count: 10,
          page: this.page,
          order: -1,
        };
        const res = await getNotificationData(payload);
        if (res.status === 200) {
          this.isLoading = false;
          const newItems = res.data.data.data.map((n) => ({
            ...n,
            activeDropdownIndex: false,
          }));
          if (this.page === 0) {
            this.notifications = newItems;
          } else {
            this.notifications = [...this.notifications, ...newItems];
          }
          this.total = res.data.data.totalCount;
          this.pageEnd = res.data.data.pageEnd;
          this.showLoader = false;
        }
      } catch (error) {
        console.error(error);
        this.isLoading = false;
      }
    },
    handleScroll(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
          target.scrollHeight - target.offsetHeight &&
        this.pageEnd > 0 &&
        this.pageEnd < this.total &&
        !this.showLoader
      ) {
        this.showLoader = true;
        this.page++;
        this.fetchNotifications();
      }
    },
    toggleDropdown(groupName, index) {
      const clickedItem = this.groupedNotifications[groupName][index];

      if (clickedItem.activeDropdownIndex) {
        clickedItem.activeDropdownIndex = false;
      } else {
        Object.keys(this.groupedNotifications).forEach((group) => {
          this.groupedNotifications[group].forEach((item) => {
            item.activeDropdownIndex = false;
          });
        });
        clickedItem.activeDropdownIndex = true;
      }
    },
    async toggleReadStatus(item) {
      try {
        const payload = {
          userID: this.userID,
          notificationIDs: [item.notificationID],
        };
        const res = await markasReadandUnreadNotification(payload);
        if (res.status === 200) {
          const change = item.read ? 1 : -1;
          item.read = !item.read;
          this.$emit("changeCountvalue", change);
        } else {
          this.errorToast("Something went wrong!");
        }
      } catch (err) {
        this.errorToast("Something went wrong!");
        console.error(err);
      }
    },
    async markAllRead() {
      try {
        const payload = { userID: this.userID, markAllRead: true };
        const res = await markasReadNotification(payload);
        if (res.status === 200) {
          this.$nextTick(() => {
            this.successToast("All notifications are marked as read");
          });
          this.fetchNotifications();
        } else {
          this.errorToast("Something went wrong!");
        }
      } catch (err) {
        console.error(err);
        this.errorToast("Something went wrong!");
      }
    },
    appendQuery(link, query) {
      let url = new URL(link);
      url.searchParams.append(query.key, query.value);
      return url.href;
    },
    openEvent(event) {
      let finalLink = event.link;
      if (
        finalLink &&
        finalLink.indexOf("https://assessment.hire3x.com/") !== -1
      ) {
        finalLink = this.appendQuery(finalLink, {
          key: "from",
          value: "candidate",
        });
      }
      if (event.link && event.link.endsWith("/categories")) {
        window.location.href = `${
          appConfig.candidateBase
        }/assessment/progress/?redirectTraining=${encodeURIComponent(
          window.location.href,
        )}`;
        this.$emit("closeNotificationDropdown");
      } else if (event.linkType === "2") {
        window.open(event.link, "_blank");
      } else {
        let finalLink = event.link;
        if (projectname === "Candidate") {
          finalLink = `/builder/${event.link}`;
        } else if (projectname === "Training") {
          finalLink = `/training/${event.link}`;
        }
        window.location.href = finalLink;
        this.$emit("closeNotificationDropdown");
      }
    },
    closenotiinsideDD(groupName, index) {
      this.groupedNotifications[groupName][index].activeDropdownIndex = false;
    },
  },
};
</script>


<style>
.notificationdd .dropdown-header {
  padding: 0.75rem 1rem !important;
  border-bottom: 1px solid #dee2e6;
}
.unread {
  background-color: #e8eff4;
  border-radius: 5px;
}
.unread:hover {
  background: #c8dceb !important;
  border-radius: 5px;
}
.notification-active-class {
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  border-radius: 4px;
}
.notificationdd .dropdown-menu {
  background-color: #ffffff;
  box-shadow: 0px 4px 34px rgba(196, 196, 196, 0.9);
  border-radius: 8px;
  border: unset;
}
.markallread {
  font-family: "Lato";
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  color: #7a7a7a;
}
.notihighlight {
  color: #20639b;
  font-weight: 600;
}
.notiitems:hover {
  background: linear-gradient(0deg, #f6f6f6, #f6f6f6), #e8eff4;
  border-radius: 5px;
}
.notificationdd .dropdown-menu {
  background-color: #ffffff;
  box-shadow: 0px 4px 34px rgba(196, 196, 196, 0.9);
  border-radius: 8px;
  border: unset;
}
.w-10 {
  width: 10% !important;
}
.notificationdd .btn:focus,
.btn.focus {
  box-shadow: unset;
}
.notifications-dropdown {
  width: 435px;
  max-height: 595px;
  overflow-y: auto;
  right: -5px;
  top: 57px;
  background-color: #ffffff;
  box-shadow: 0px 4px 34px rgba(196, 196, 196, 0.9);
  border-radius: 8px;
  position: absolute;
}
.notification-hr {
  border-top: 1px solid #dddddd;
  opacity: unset;
}
.notification-count-tag {
  background: #ad1927;
  border-radius: 100px;
  position: absolute;
  top: -1px;
  width: fit-content;
  padding: 0 5px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.notification-markasread-dd {
  width: 189px;
  height: 31px;
  background: #ffffff;
  border-radius: 4px;
  filter: drop-shadow(0px 8px 15px rgba(0, 0, 0, 0.4));
  position: absolute;
  right: 0;
  top: 15px;
}
.gap10px {
  gap: 10px;
}
.gap5px {
  gap: 5px;
}
.font-normal {
  font-style: normal;
}
.w-70 {
  width: 70%;
}
.gap10px {
  gap: 10px;
}
.gap5px {
  gap: 5px;
}
.font-normal {
  font-style: normal;
}
.w-70 {
  width: 70%;
}
.w-80 {
  width: 80%;
}
.notification-markasread-dd:hover {
  background: #e8eff4;
}
.maxheight450px {
  max-height: 450px;
}
.mobmy0 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}
@media (max-width: 1028px) {
  .notification-main-container {
    position: relative;
    z-index: 25;
    background-color: #e9ecef;
    position: fixed;
    /* height: 100%; */
    width: 100%;
    top: calc(0px + env(safe-area-inset-top));
    height: calc(
      100dvh - (0px + env(safe-area-inset-top) + env(safe-area-inset-bottom))
    );
  }
  .notification-mobile-header {
    letter-spacing: 1px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    font-weight: var(--weight-LM);
    font-family: "Lato", sans-serif;
    font-size: var(--size-18);
    color: var(--cv-black);
    padding-left: 20px;
    box-shadow: 0px 4px 4px 0px #00000014;
    width: 100%;
    position: relative;
    /* position: fixed; */
    /* top: 0px; */
    z-index: 22;
    /* padding-top: env(safe-area-inset-top) !important; */
    height: 60px;
    padding-right: 16px;
  }
  .notifications-dropdown {
    height: calc(100% - 88px) !important;
    margin: 15px 10px 20px 10px;
    width: 94% !important;
    background: #ffffff;
    border-radius: 4px;
    position: unset;
    max-height: unset;
  }
  .height100dvh {
    height: 100dvh;
    width: 100%;
  }
  .mobh100 {
    max-height: 100% !important;
    height: 100% !important;
  }
  .notification-count-tag {
    top: -1px !important;
    /* right: -5px !important; */
  }
  .notification-markasread-dd {
    width: 115px !important;
    color: #344054;
  }
  .mobmy0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}
</style>
